module.exports = __webpack_public_path__ + "img/offer2.81efc237.jpg";